export const SESSIONS_KEY = 'deinverband:devSessions';

export interface Session {
  id: string;
  name: string;
  session: string;
}

export interface AuthContextType {
  signInWithEmailAndPassword?: (
    email: string,
    password: string
  ) => Promise<void>;
  signInRedirect?: () => Promise<void>;
  signInCallback?: () => Promise<void>;
  signOut: (reason?: string) => Promise<void>;
  // user management
  updatePassword?: (current: string, password: string) => Promise<void>;
  resetPassword?: (email: string) => Promise<void>;
  // development tools
  saveSession?: (storageId: string, sessionName: string) => void;
  loadSession?: (storage: string) => void;
}

export const getSessions = (): Session[] => {
  const sessions = localStorage.getItem(SESSIONS_KEY);
  return sessions ? JSON.parse(sessions) : [];
};

export const getSession = (storageId: string) => {
  const sessions = getSessions();
  const session = sessions.find((session) => session.id === storageId);
  if (!session) throw new Error('Session not found');

  return session;
};

export const addSession = (
  storageId: string,
  sessionName: string,
  session: string | null
) => {
  if (!session) throw new Error('Session not provided');
  const sessions = getSessions();

  // insert or update the session
  localStorage.setItem(
    SESSIONS_KEY,
    JSON.stringify([
      ...sessions.filter((session) => session.id !== storageId),
      { id: storageId, name: sessionName, session }
    ])
  );
};
